import React, { useState, useEffect } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import jsDig from "utils/jsDig";
import { v4 as uuidv4 } from "uuid";
import CustomTooltip from "utils/CustomTooltip";

export default function Details(props) {
  const website = jsDig(["client_account", "websites", "primary"], props);
  const additionalWebsites = jsDig(["client_account", "websites", "additional"], props);
  const [primarySite, setPrimarySite] = useState(website);
  const [additionalWebs, setAdditionalWebs] = useState(additionalWebsites ? additionalWebsites : []);
  const [platform, setPlatform] = useState(props.client_account.website_platform ? props.client_account.website_platform : "0");
  const [shopifyUrl, setShopifyUrl] = useState(props.client_account.shopify_url ? props.client_account.shopify_url : "");

  let shopifyIcon = require("images/logos/shopify-icon.png");
  shopifyIcon = <img className="shopify-icon" style={{ width: "15px", position: "relative", top: "-2px", left: "5px" }} src={`/datapulse${shopifyIcon}`} />;
  const resetMessage = "Resetting Shopify token will require you to authenticate again";

  const authenticateFunction = () => {
    const paramsObject = {
      shopify_url: shopifyUrl,
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/shopify-authenticate",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        window.open(data.permission_url, "_blank");
        //change it back to below before push
        // window.location.href = data.redirect_url;
      },
    }).then(setShopifyButton(resetButton));
  };

  const authenticateButton = (
    <Button className="mb-4 mt-2 center-mobile-button px-4 mr-3 btn-lg text-center" variant="success" onClick={authenticateFunction}>
      Authenticate
      {shopifyIcon}
    </Button>
  );
  const resetToken = () => {
    let myObject = {
      shopify_token: "",
      client_account_id: props.client_account.id,
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/reset_token",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(myObject),
    });
    setShopifyButton(authenticateButton);
  };

  const resetButton = (
    <>
      <Button className="my-4 btn-lg px-4 mr-3 text-center" variant="danger" onClick={resetToken}>
        Reset Token
        {shopifyIcon}
      </Button>
      <CustomTooltip faClass="far fa-question-circle f18 pl-0" message={resetMessage} inline={true} />
    </>
  );
  const [shopifyButton, setShopifyButton] = useState(
    props.client_account.shopify_token === null || props.client_account.shopify_token === "" ? authenticateButton :
    platform == "0" && !props.client_account.shopify_token && props.client_account.shopify_url && props.client_account.shopify_url != ""
      ? authenticateButton
      : resetButton
  );

  const handleOnChange = (e, i) => {
    let newArray = additionalWebs;
    newArray[i].url = e.target.value;
    setAdditionalWebs([...newArray]);
  };

  const handleDelete = (i) => {
    setAdditionalWebs(
      additionalWebs.filter((web) => {
        return web.id !== i;
      })
    );
  };

  const addRow = () => {
    let newitem = {};
    newitem.url = "";
    newitem.id = uuidv4();
    setAdditionalWebs([...additionalWebs, newitem]);
  };

  let renderAdditionalWebs = additionalWebs.map((website, index) => {
    return (
      <Row className="m-0 align-items-center" key={website.id}>
        <input
          size="sm"
          className="tableSearch mr-2 mb-2 col col-10 "
          placeholder=""
          name={`websites[additional][][url]`}
          value={website ? website.url : ""}
          onChange={(e) => handleOnChange(e, index)}
        />
        <input type="hidden" name="websites[additional][][id]" value={website.id} />
        <button type="button" onClick={() => handleDelete(website.id)}>
          <i className="mb-2 fas fa-minus-circle"></i>
        </button>
      </Row>
    );
  });

  return (
    <Row className="mx-4 trim-margin">
      <Col className="pl-0 pr-4 pt-3 mt-2 trim-padding" md={7} xs={12} style={{ backgroundColor: "#EEEEEE" }}>
        <Row className="col-12 web-details m-0 ">
          <Col className="py-2 col-12">
            <Row>
              <h3 className="section-header">Website/Domain Details</h3>
            </Row>
          </Col>
        </Row>
        <Row className="col-12 pt-0 pl-4 pr-0 pb-2 m-0">
          <Col className="col-11 py-3 pr-0 trim-padding">
            <p className="primary">
              <strong>Navigate to your website in a browser, and copy and paste the URL directly from the address bar. </strong>
              To add additional websites or subdomains (ie. if your primary website is "example.com" and you need to add "shop.example.com"), click the 'Add'
              button to create a new field and follow the same process in the new field with every entry.
            </p>
          </Col>
        </Row>
        <Row className="col-12 pt-2 pl-4 pr-4 pb-2 m-0 trim-padding">
          <Col md={10} xs={12}>
            <Form.Group controlid="primarySite pb-4">
              <Row>
                <Col>
                  <Form.Label className="pr-3 pb-1 pl-2 trim-padding">
                    <h6 style={({ color: "#55588F" }, { fontFamily: "visby-bold" })}>Primary Website</h6>
                  </Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Form.Control
                    size="sm"
                    className="tableSearch mr-2 mb-2 col col-10"
                    type="url"
                    placeholder=""
                    name="websites[primary]"
                    value={primarySite ? primarySite : ""}
                    onChange={(e) => setPrimarySite(e.target.value)}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlid="addSite pb-4">
              <Form.Label className="pr-3 pb-1 pl-2 trim-padding">
                <h6 style={({ color: "#55588F" }, { fontFamily: "visby-bold" })}>Additional websites/subdomains</h6>
              </Form.Label>
              {renderAdditionalWebs}
              <Row className="m-0">
                <Button className="my-4 py-1 btn-sm px-4 mr-3 text-center center-mobile-button" variant="success" onClick={() => addRow()}>
                  + Add subdomain
                </Button>
              </Row>
            </Form.Group>
          </Col>
        </Row>
      </Col>
      <Col className="px-3 px-lg-5 pt-4 mt-2" style={{ backgroundColor: "#EEEEEE" }}>
        <Row>
          <Col>
            <h3 className="section-header py-2">Platform</h3>
          </Col>
        </Row>
        <Row>
          <Col className="pb-3">
            <Form.Group controlid="shopOrLead">
              <Form.Control
                size="sm"
                as="select"
                style={{ color: "#2c345b " }}
                value={platform}
                className="pr-0 col-5"
                name="website_platform"
                onChange={(e) => {
                  setPlatform(e.target.value);
                }}>
                <option value="0">Shopify</option>
                <option value="1">BigCommerce</option>
                <option value="2">Magento</option>
                <option value="3">Wordpress</option>
                <option value="4">Other</option>
              </Form.Control>
            </Form.Group>
            {platform === "0" && (
              <>
                <h6 className="pb-2" style={({ color: "#55588F" }, { fontFamily: "visby-bold" })}>
                  Shopify URL
                </h6>
                <Form.Control size="sm" value={shopifyUrl} name="shopify_url" placeholder="example.myshopify.com" onChange={(e) => setShopifyUrl(e.target.value)} />
              </>
            )}
          </Col>
        </Row>
        {platform === "0" &&
        <>
          <Row>
            <Col>
            <p className="f10">If changing the URL you must press "Save Changes" before you can "Authenticate" </p>
            
            </Col>
          </Row>
          <Row>
          <Col className="pb-3">{shopifyButton}</Col>
        </Row>
        </>
        }
        <Row className="">
          <Col>
            <h3 className="section-header pb-2">Capabilities</h3>
          </Col>
        </Row>
        <Row className="">
          <Col>
            <Form.Group controlid="capabilities">
              <h6 className="ml-2" style={({ color: "#55588F" }, { fontFamily: "visby-bold" })}>
                Development
              </h6>
              <Form.Control
                as="select"
                style={{ color: "#2c345b " }}
                className="pr-0 col-9"
                size="sm"
                name="development_capabilities"
                defaultValue={props.client_account.development_capabilities ? props.client_account.development_capabilities : 0}>
                <option value="0">In-house full-time developers</option>
                <option value="1">Contracted developers part-time</option>
                <option value="2">None</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className="">
          <Col>
            <Form.Group controlid="creative-capabilities">
              <h6 className="ml-2" style={({ color: "#55588F" }, { fontFamily: "visby-bold" })}>
                Creative
              </h6>
              <Form.Control
                as="select"
                style={{ color: "#2c345b " }}
                className="pr-0 col-9"
                size="sm"
                name="creative_capabilities"
                defaultValue={props.client_account.creative_capabilities ? props.client_account.creative_capabilities : 0}>
                <option value="0">In-house full-time creative</option>
                <option value="1">Contracted creative part-time</option>
                <option value="2">None</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}